module.exports = __webpack_public_path__ + "static/media/06.2d988f85.mp3";